export class Application {
  public id: string;
  public label: string;
  public shortLabel: string;
  public description: string;
  public active: boolean;
  public iconMenu: string;
  public iconActive: string;
  public iconDisable: string;
  public logoActive: string;
  public logoDisable: string;
  public appType: { id: string; label: string };
  public urlDoc: string;
  public urlApp: string;
  public route: string;

  public getImage(): string {
    return `assets/images/logo/${this.iconActive}`;
  }

  public getTitle(): string {
    return this.label;
  }
}
